import React from "react";
import { useEffect, useState } from "react";
import { TCaseSearchResult } from "../../../../../domain/codecs/CaseSearchResult";
import { CRMButtonTertiary } from "../../CRMButtonTertiary/CRMButtonTertiary";
import { CRMSearchCaseCard } from "../CRMSearchCaseCard/CRMSearchCaseCard";
import { CRMSearchOverlayShell } from "./CRMSearchOverlayShell";

type TCaseSearchOverlayProps = {
    isOpen: boolean;
    searchValue: string;
    cases: Array<TCaseSearchResult>;
    onChange: (searchValue: string) => void;
    onClose: () => void;
};

const getCaseCardButtons = (caseId: string) => [
    {
        label: "Details",
        link: `/crm/legal/cases/${caseId}?visible_tab=details`
    },
    {
        label: "Documents",
        link: `/crm/legal/cases/${caseId}?visible_tab=document_management`
    },
    {
        label: "Enquiries",
        link: `/crm/legal/cases/${caseId}?visible_tab=enquiries`
    },
    {
        label: "Emails",
        link: `/crm/legal/cases/${caseId}?visible_tab=emails`
    },
];

export const CRMCaseSearchOverlay = (props: React.PropsWithChildren<TCaseSearchOverlayProps>): JSX.Element => {

    const inputRef = React.createRef<HTMLInputElement>();

    const [arePropertyReportsExpanded, setArePropertyReportsExpanded] = useState(false);

    const propertyReportCases = props.cases.filter((legalCase) => legalCase.status === "property_report");
    const otherCases = props.cases.filter((legalCase) => legalCase.status !== "property_report");
    const arePropertyReportsFoldable = propertyReportCases.length > 1;

    const togglePropertyReports = () => {
        setArePropertyReportsExpanded(!arePropertyReportsExpanded);
        inputRef.current?.focus();
    }

    useEffect(
        () => setArePropertyReportsExpanded(false),
        [props.searchValue]
    )

    return (
        <CRMSearchOverlayShell
            isOpen={props.isOpen}
            searchValue={props.searchValue}
            placeholder="Search for cases by address or client name"
            onChange={props.onChange}
            onClose={props.onClose}
            inputRef={inputRef}
        >
            {otherCases.map((legalCase, key) => (
                <CRMSearchCaseCard
                    key={key}
                    case={legalCase}
                    buttons={getCaseCardButtons(legalCase.id)}
                />
            ))}

            {arePropertyReportsFoldable &&
                <CRMButtonTertiary
                    fullWidth={true}
                    highlight="calming-pink"
                    icon={arePropertyReportsExpanded ? "up-arrow" : "down-arrow"}
                    label={`${arePropertyReportsExpanded ? "Hide" : "Show"} ${propertyReportCases.length} property reports`}
                    onClick={togglePropertyReports}
                />
            }

            {(!arePropertyReportsFoldable || arePropertyReportsExpanded) &&
                propertyReportCases.map((legalCase, key) => (
                    <CRMSearchCaseCard
                        key={key}
                        case={legalCase}
                        buttons={getCaseCardButtons(legalCase.id)}
                    />
                ))
            }
        </CRMSearchOverlayShell>
    );
};
